import React, { Component } from 'react';
import OrderTabQAItemNew from './OrderTabQAItemNew';
import QACollapseItemNew from './QACollapseItemNew';
import StarRating from './shared/StarRating';
import grading from './../styles/grading.styl';

import { dataCriterion, notNullCriterion, dataCriterionCorrectAnswer } from './../constants/dataQACategoryNew';

const SHORT_SUBJECT_TYPE_OTHER_CRITERIA = [
  'humanities', 'social', 'business', 'literature', 'it',
];

class OrderTabQANew extends Component {
  constructor(props) {
    super(props);

    this.dataCriterionState = dataCriterion;

    this.state = {
      qaReport: this.props.order.qa_report || {},
      loading: false,
      graderRating: this.props.order.qa_report_score || null,
    };
  }

  componentDidMount() {
    const { qa_report: qaReport, qa_report_score: qaReportScore } = this.props.order;
    const { profile } = this.props;
    const { subject_type: subjectType } = profile;

    this.dataCriterionState = SHORT_SUBJECT_TYPE_OTHER_CRITERIA.includes(subjectType) ? dataCriterion : dataCriterionCorrectAnswer;
    if (qaReportScore > 0 && !Object.keys(qaReport).includes('correct_answers')) {
      this.dataCriterionState = dataCriterion;
    }
    this.getGraderSum(this.props.order.qa_report || {});
  }

  getGraderSum(qaReport) {
    const keys = Object.keys(this.dataCriterionState);
    let totalSum = 0;

    keys.map((idCriterion) => {
      const keysSection = Object.keys(this.dataCriterionState[idCriterion].data);

      const resSumOut = keysSection.reduce((sumOut, current) => {
        return sumOut + (qaReport[current] || 0);
      }, 0);

      const resSumOf = keysSection.reduce((sumOf, current) => {
        return sumOf + this.dataCriterionState[idCriterion].data[current].grade[0];
      }, 0);

      this.setState({
        [idCriterion]: {
          sumOf: Number(resSumOf).toFixed(1),
          sumOut: Number(resSumOut).toFixed(1),
        },
      });

      totalSum += resSumOut;
    });

    let graderRating = Number(totalSum).toFixed(1);

    notNullCriterion.map((idCriterion) => {
      if (this.dataCriterionState[idCriterion]) {
        const keysCriterion = Object.keys(this.dataCriterionState[idCriterion].data);
        if (keysCriterion.some(current => qaReport[current] < 0.0001)) {
          graderRating = 1;
        }
      }
    });

    const graderRatingValue = Number(graderRating) > 0 ? Number(graderRating) : 1;

    this.setState({
      graderRating: graderRatingValue,
    });
  }


  getFillRating(graderRating) {
    let fill = '#fc694f';

    if (graderRating >= 3 && graderRating <= 3.9) {
      fill = '#ffa525';
    }

    if (graderRating >= 4) {
      fill = '#12ca86';
    }
    return fill;
  }

  getTitleCategory(itemCriterion) {
    if (this.state[itemCriterion] && this.state[itemCriterion].sumOf && this.state[itemCriterion].sumOut) {
      const sumOut = this.state[itemCriterion].sumOut;
      const sumOf = this.state[itemCriterion].sumOf;

      return `${Number(sumOut).toFixed(1) || 0} out of ${Number(sumOf).toFixed(1)}`;
    }
  }

  getRatingString(graderRating) {
    let graderRatingStr = '(1)';

    if (graderRating >= 1) {
      graderRatingStr = `(${graderRating})`;
    }

    return graderRatingStr;
  }

  render() {
    const { order } = this.props;
    const { graderRating, qaReport } = this.state;

    const dataCriterionKeys = Object.keys(this.dataCriterionState);
    const fill = this.getFillRating(graderRating);
    return (
      <div className={grading.grade_box}>
        <div className={grading.grade_sum}>
          <h3 className={grading.grade_box_head}>Your grade:</h3>
          <StarRating rate={graderRating} width={140} customFill={fill} />
          <span>{this.getRatingString(graderRating)}</span>
        </div>
        {order.grading_comment &&
          <div className={grading.grading_comment}><b>Comment:</b> <br/> {order.grading_comment}</div>
        }

        {qaReport &&
          dataCriterionKeys.map(itemCriterion => (
            <div className={grading.person_info_box} key={itemCriterion}>
              <QACollapseItemNew
                title={this.dataCriterionState[itemCriterion].name}
                titleCounters={this.getTitleCategory(this.dataCriterionState[itemCriterion].id)}
                key={`collapse_${itemCriterion}`}
              >
                <OrderTabQAItemNew
                  dataSection={this.dataCriterionState[itemCriterion]}
                  setTitle={this.setTitle}
                  dataRow={qaReport}
                  key={`category_${itemCriterion}`}
                />
              </QACollapseItemNew>
            </div>
          ))
        }

      </div>
    );

  }
}

export default OrderTabQANew;



// WEBPACK FOOTER //
// ./src/components/OrderTabQANew.js